import React from "react";
import { Tabs, Tab, Box, Divider } from "@mui/material";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import BackButton from "../../../components/BackButton";
import { useEffect } from "react";
import { useAuthContext } from "../../../context/AuthContext";
import ComInfo from "./ComInfo";
import ProjList from "./ProjList";
import ComCatList from "./ComCatList";
import ComEmp from "./ComEmp";
import NotApprComEmp from "./NotApprComEmp";
import NotApprDept from "./NotApprDept";
import constants from "../../../utils/Constants";
import ComEmpSrc from "./ComEmpSrc";


function CompanyDetailsPage() {
    const navigate = useNavigate()
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const comId = searchParams.get("comId");
    const activeTab = parseInt(searchParams.get("tab") || "0");
    const { setNavComValue, ctxtUser } = useAuthContext();
    const tabs = [
        "Company Details",
        "Project",
        "Catalog",
        "Employees",
        ...(ctxtUser?.userType === constants.admin ? ["Employees Request", "Department Request", "Inactive Employees"] : [])
    ];

    useEffect(() => {
        if (!comId)
            navigate("/", { replace: true })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comId])



    useEffect(() => {
        setNavComValue({ comId })
        return () => setNavComValue({ comId: "" }); // Reset when leaving the page
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, comId]);

    function handleTabChange(event, newValue) {
        // setSearchParams(prev => {
        //     prev.set("tab", encodeURIComponent(newValue))
        //     return prev
        // }, { replace: true })
        const newParams = new URLSearchParams();
        newParams.set("tab", encodeURIComponent(newValue));
        newParams.set("comId", encodeURIComponent(comId)); // Set the "tab" param
        setSearchParams(newParams); // Replace existing search params with the new one
    };


    function TabContent() {
        switch (activeTab) {
            case 0:
                return <ComInfo comId={comId} />;
            case 1:
                return <ProjList aComId={comId} />;
            case 2:
                return <ComCatList aComId={comId} />;
            case 3:
                return <ComEmp aComId={comId} />;
            case 4:
                return <NotApprComEmp aComId={comId} />;
            case 5:
                return <NotApprDept aComId={comId} />;
            case 6:
                return <ComEmp aComId={comId} status="0" />;
            default:
                return null;
        }
    };

    function TabContentSrc() {
        switch (activeTab) {
            case 0:
                return <ComInfo comId={comId} />;
            case 1:
                return <ProjList aComId={comId} />;
            case 2:
                return <ComCatList aComId={comId} />;
            case 3:
                return <ComEmpSrc aComId={comId} />;
            default:
                return null;
        }
    };


    return (<>
        <BackButton />
        {ctxtUser?.userType === constants.admin &&
            <Box sx={{ width: "100%", height: "95%", border: 1, borderColor: "rgba(0, 0, 0, 0.2)", borderRadius: 3, mt: 1 }}>
                <Tabs value={activeTab} onChange={handleTabChange} textColor="inherit" sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between", // Ensures equal spacing
                    '& .MuiTab-root': {
                        flexGrow: 1, // Makes each tab take equal space
                        color: "text.secondary",
                    },
                }}>
                    {tabs.map((label, index) => (<Tab key={label} label={label} sx={getTabStyles(activeTab === index)} />))}
                </Tabs>
                <Divider sx={{ bgcolor: 'primary.main' }} />
                {TabContent()}
            </Box>}


        {ctxtUser?.userType === constants.sourcing &&
            <Box sx={{ width: "100%", height: "95%", border: 1, borderColor: "rgba(0, 0, 0, 0.2)", borderRadius: 3, mt: 1 }}>
                <Tabs value={activeTab} onChange={handleTabChange} textColor="inherit" sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between", // Ensures equal spacing
                    '& .MuiTab-root': {
                        flexGrow: 1, // Makes each tab take equal space
                        color: "text.secondary",
                    },
                }}>
                    {tabs.map((label, index) => (<Tab key={label} label={label} sx={getTabStyles(activeTab === index)} />))}
                </Tabs>
                <Divider sx={{ bgcolor: 'primary.main' }} />
                {TabContentSrc()}
            </Box>}
    </>
    )
}
export default CompanyDetailsPage

function getTabStyles(isActive) {
    return {
        bgcolor: isActive ? "primary.main" : "transparent",
        color: isActive ? "black" : "rgba(0, 0, 0, 0.45)",
        borderRadius: "10px 10px 0 0",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        "&:hover": { bgcolor: "primary.light" },
    }
};